import React from 'react';
import { Flex, Grid, Input } from '@mantine/core';
import { idCreator } from '../../../../Project/utils/idCreator';

export function FilterInput({ idPrefix, label, options = [], selected, onSelect }) {
  const rootId = idPrefix || 'semi-extraction-filter-input';
  const labelId = idCreator(label);

  return (
    <Input.Wrapper id={`${rootId}-wrapper-${labelId}`} label={label} mt="10px">
      <Flex id={`${rootId}-row-${labelId}`} align="center" mt="2">
        <Grid id={`${rootId}-grid-${labelId}`} w="100%" gutter="sm" grow>
          {options.map(value => (
            <Grid.Col
              id={`${rootId}-option-${labelId}-${value}`}
              key={value}
              span={1}
              onClick={() => onSelect(value)}
            >
              <Flex
                id={`${rootId}-option-button-${labelId}-${value}`}
                style={{
                  borderRadius: '4px',
                  color: selected === value ? '#fff' : '#000',
                  cursor: 'pointer'
                }}
                justify="center"
                bg={selected === value ? 'blue.6' : 'gray.1'}
                py="4"
                fz="sm"
              >
                {value}
              </Flex>
            </Grid.Col>
          ))}
        </Grid>
      </Flex>
    </Input.Wrapper>
  );
}
